import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Row } from "reactstrap";
import { IRootState } from "../../reducers";
import { getEntities as getApplications } from "../../reducers/applicationsReducer";
import { getEntities as getProvinces } from "../../reducers/provinceReducer";
import { IApplication } from "../../shared/model/application.model";
import { IFilterApplication } from "./application-filter-interface";
import { Banner } from "../../shared/layout/banner";
import ApplicationFilter from "./application-filter";
import { SpinnerKonecta } from "../../shared/layout/spinner/Spinner";
import { ApplicationCardList } from "./application-card-list";
import { ModalError } from "../../shared/dialog/modal-error";
import { overridePaginationStateWithQueryParams, useOverrideFilterApplication } from "../../shared/utils/entity-utils";
import { ITEMS_PER_PAGE } from "../../shared/utils/pagination.constants";
import { getSortState } from "../../shared/utils/pagination-utils";
import { Paginations } from "../../shared/components/pagination/Pagination";

interface IApplicationComponent
  extends StateProps,
    DispatchProps,
    RouteComponentProps<any> {}

export const initialStateFilter: IFilterApplication = {
  name: "",
  provinces: [],
};
export const provincesIds = (provinces: Array<any>): any[] => {
  const ids: any[] = provinces.length ? provinces.map((p) => p) : [];
  return ids;
};

export const Home = (props: IApplicationComponent) => {
  const { applications, loading, provinces, history } = props;

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  // ONLY CHANGE WHEN FORM IS SUBMITTED
  const [filterLocationSearch, setFilterLocationSearch] = useState<IFilterApplication>(useOverrideFilterApplication(props.location.search));

  // CHANGE WHEN ANY FILTER INPUT CHANGES
  const [filterData, setFilterData] = useState<IFilterApplication>(useOverrideFilterApplication(props.location.search));

  const handleClose = () => {
    window.location.reload();
  };

  const getAllEntities = () => {
    const filter = `&name=${filterLocationSearch.name}&provinces=${JSON.stringify(filterLocationSearch.provinces)}`;
    props.getApplications(
      paginationState.activePage - 1,
      paginationState.itemsPerPage,
      `${paginationState.sort},${paginationState.order}`,
      `${filter}`
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const filter = `&name=${filterLocationSearch.name}&provinces=${JSON.stringify(filterLocationSearch.provinces)}`;
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}${filter}`;

    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setFilterData({
      ...filterData,
      [e.target.name]: e.target.value,
    });
  };

  // SEND FORM
  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    setFilterLocationSearch({
      ...filterData
    });
  };
  const handlePagination = currentPage => {
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get('sort');
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  useEffect(() => {
    props.getProvinces();
  }, []);

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, filterLocationSearch]);

  return (
    <>
      <div className="header-gradient">
        <Banner />
        <ApplicationFilter
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          provinces={props.provinces}
          setFilterData={setFilterData}
          filterData={filterData}
        />
      </div>
      {loading ? (
        <SpinnerKonecta />
      ) : (
        <>
          <div className="div-card-list">
            {applications?.length ? (
              <>
                <div className="container-card-list">
                  {applications.map(
                    (currentValue: IApplication, index: number) => (
                      <ApplicationCardList
                        key={currentValue.id}
                        application={currentValue}
                      />
                    )
                  )}
                </div>
                {props.totalItems ? (
                  <div>
                    <Paginations
                      activePage={paginationState.activePage}
                      totalItems={props.totalItems}
                      itemsPerPage={paginationState.itemsPerPage}
                      handlePagination={handlePagination}
                    />
                  </div>
                ) : (
                  ""
                )}
              </>
              
            ) : (
              <Row className="alert-main-page justify-content-center">
                <div className="alert alert-warning">
                  No se encontraron búsquedas activas
                </div>
              </Row>
            )}
          </div>
        </>
      )}
      {props.errorMessage ? (
        <ModalError error={props.errorMessage} handleClose={handleClose} />
      ) : undefined}
      {props.errorMessageProvinces ? (
        <ModalError
          error={props.errorMessageProvinces}
          handleClose={handleClose}
        />
      ) : undefined}
    </>
  );
};

const mapStateToProps = (storeState: IRootState) => {
  return {
    store: storeState,
    applications: storeState.applicationReducer.entities,
    totalItems: storeState.applicationReducer.totalItems,
    loading: storeState.applicationReducer.loading,
    provinces: storeState.provinceReducer.entities,
    errorMessageProvinces: storeState.provinceReducer.errorMessage,
    errorMessage: storeState.applicationReducer.errorMessage,
  };
};

const mapDispatchToProps = {
  getApplications,
  getProvinces,
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
